import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import Junkremovalheader from '../components/Servicelist7/Junkremovalheader'
import Junkremovaldetails from '../components/Servicelist7/Junkremovaldetails'

const Junkremovapage = () => {
    return (
        <div>
        <Navbar/>
        <Junkremovalheader/>
        <Junkremovaldetails/>




        <Footer/>



        </div>
    )
}

export default Junkremovapage